/* ===================================================================
   CHASING GHOSTS — theme.js
   Site-wide interactions: custom cursor, header, cart drawer, hero,
   scramble text, bfcache handling.
   =================================================================== */
(function(){
'use strict';

// ============ CUSTOM CURSOR + PHANTOM TRAIL ============
const cursor = document.getElementById('cursor');
const cursorTrail = document.getElementById('cursorTrail');
const trailDots = [
  {el: document.getElementById('td1'), lag: 0.22, x: 0, y: 0},
  {el: document.getElementById('td2'), lag: 0.16, x: 0, y: 0},
  {el: document.getElementById('td3'), lag: 0.12, x: 0, y: 0},
  {el: document.getElementById('td4'), lag: 0.08, x: 0, y: 0},
  {el: document.getElementById('td5'), lag: 0.05, x: 0, y: 0}
].filter(d => d.el);

let mouseX = 0, mouseY = 0, trailX = 0, trailY = 0;
if(cursor){
  document.addEventListener('mousemove', e => {
    mouseX = e.clientX; mouseY = e.clientY;
    cursor.style.left = mouseX + 'px';
    cursor.style.top = mouseY + 'px';
  });
  function animateTrail(){
    trailX += (mouseX - trailX) * 0.18;
    trailY += (mouseY - trailY) * 0.18;
    if(cursorTrail){
      cursorTrail.style.left = trailX + 'px';
      cursorTrail.style.top = trailY + 'px';
    }
    trailDots.forEach(d => {
      d.x += (mouseX - d.x) * d.lag;
      d.y += (mouseY - d.y) * d.lag;
      d.el.style.left = d.x + 'px';
      d.el.style.top = d.y + 'px';
    });
    requestAnimationFrame(animateTrail);
  }
  animateTrail();
  document.querySelectorAll('a, button, .product-card, .size-btn, .color-swatch, .gallery-thumb').forEach(el => {
    el.addEventListener('mouseenter', () => { cursor.classList.add('hover'); if(cursorTrail) cursorTrail.classList.add('hover'); });
    el.addEventListener('mouseleave', () => { cursor.classList.remove('hover'); if(cursorTrail) cursorTrail.classList.remove('hover'); });
  });
}

// ============ HEADER SCROLL STATE ============
const header = document.getElementById('siteHeader');
if(header){
  window.addEventListener('scroll', () => {
    if(window.scrollY > 80) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
  }, { passive: true });
}

// ============ SCRAMBLE TEXT ============
const scrambleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
function scramble(el){
  if(!el || el.dataset.scrambling === '1') return;
  const target = el.dataset.text || el.textContent;
  let targetNode = el;
  if(el.tagName === 'BUTTON' && el.querySelector('span')) targetNode = el.querySelector('span');
  el.dataset.scrambling = '1';
  const dur = 320;
  const start = performance.now();
  function frame(now){
    const t = Math.min(1, (now - start) / dur);
    const reveal = Math.floor(t * target.length);
    let out = '';
    for(let i = 0; i < target.length; i++){
      if(i < reveal || target[i] === ' ') out += target[i];
      else out += scrambleChars[Math.floor(Math.random() * scrambleChars.length)];
    }
    targetNode.textContent = out;
    if(t < 1) requestAnimationFrame(frame);
    else { targetNode.textContent = target; el.dataset.scrambling = '0'; }
  }
  requestAnimationFrame(frame);
}
const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
if(supportsHover){
  document.querySelectorAll('.scramble').forEach(el => {
    el.addEventListener('mouseenter', () => scramble(el));
  });
}

// ============ CART DRAWER (Shopify AJAX) ============
const cartTrigger = document.getElementById('cartTrigger');
const cartOverlay = document.getElementById('cartOverlay');
const cartDrawer  = document.getElementById('cartDrawer');
const cartClose   = document.getElementById('cartClose');

function openCart(){ if(cartOverlay) cartOverlay.classList.add('open'); if(cartDrawer) cartDrawer.classList.add('open'); }
function closeCart(){ if(cartOverlay) cartOverlay.classList.remove('open'); if(cartDrawer) cartDrawer.classList.remove('open'); }
if(cartTrigger) cartTrigger.addEventListener('click', e => { e.preventDefault(); openCart(); });
if(cartClose)   cartClose.addEventListener('click', closeCart);
if(cartOverlay) cartOverlay.addEventListener('click', closeCart);

// Fetch + re-render cart drawer contents from Shopify
async function refreshCart(){
  try {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await res.json();
    renderCart(cart);
    updateCartCount(cart.item_count);
  } catch(err){ console.warn('[cart] refresh failed', err); }
}
function updateCartCount(n){
  document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = 'bag · ' + n; el.dataset.text = 'bag · ' + n; });
  const head = document.querySelector('.cart-head h3 small span');
  if(head) head.textContent = n;
}
function money(cents){
  const val = (cents / 100).toFixed(2);
  return (window.CG_CURRENCY || 'Dhs. ') + val;
}
function renderCart(cart){
  const items = document.querySelector('.cart-items');
  if(!items) return;
  if(cart.items.length === 0){
    items.innerHTML = '<div class="cart-empty">no items yet.</div>';
  } else {
    items.innerHTML = cart.items.map(i => `
      <div class="cart-item" data-key="${i.key}">
        <div class="cart-item-img"><img src="${i.image || ''}" alt=""></div>
        <div>
          <div class="cart-item-name">${i.product_title}</div>
          <div class="cart-item-variant">${(i.variant_options||[]).filter(Boolean).join(' · ')}</div>
          <div class="cart-qty">
            <button data-cart-decrement="${i.key}">−</button>
            <span>${i.quantity}</span>
            <button data-cart-increment="${i.key}">+</button>
          </div>
          <button class="cart-item-remove" data-cart-remove="${i.key}">Remove</button>
        </div>
        <div class="cart-item-price">${money(i.final_line_price)}</div>
      </div>
    `).join('');
  }
  const sub = document.querySelector('.cart-subtotal-amount');
  if(sub) sub.textContent = money(cart.total_price);
}
async function cartChange(line, qty){
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id: line, quantity: qty })
    });
    const cart = await res.json();
    renderCart(cart);
    updateCartCount(cart.item_count);
  } catch(err){ console.warn('[cart] change failed', err); }
}
document.addEventListener('click', (e) => {
  const inc = e.target.closest('[data-cart-increment]');
  const dec = e.target.closest('[data-cart-decrement]');
  const rem = e.target.closest('[data-cart-remove]');
  if(inc || dec || rem){
    const key = (inc||dec||rem).dataset.cartIncrement || (inc||dec||rem).dataset.cartDecrement || (inc||dec||rem).dataset.cartRemove;
    const row = document.querySelector('[data-key="'+key+'"] .cart-qty span');
    const cur = row ? parseInt(row.textContent, 10) : 0;
    const newQty = rem ? 0 : (inc ? cur + 1 : Math.max(0, cur - 1));
    cartChange(key, newQty);
  }
});

// Refresh cart on load + whenever the drawer opens
refreshCart();
document.addEventListener('cg:cart-updated', refreshCart);
if(cartTrigger) cartTrigger.addEventListener('click', refreshCart);

// ============ HERO INTRO / BFCACHE STATE ============
function primeHeroForReturn(){
  document.body.classList.add('no-intro');
  document.querySelectorAll('.hero-image-main').forEach(el => { el.style.transform = ''; });
}

// ============ BACK-LINK SCROLL RESTORATION ============
// The scroll RESTORE logic runs inline in <head> (in layout/theme.liquid) so it can
// jump to position before first paint. This file just keeps saving the scroll position
// and flags it for restore when the user clicks any back-link.
const IS_HOME = document.body.classList.contains('template-index');
if(IS_HOME){
  // Continuously save scroll position while scrolling
  let scrollSaveTimer;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollSaveTimer);
    scrollSaveTimer = setTimeout(() => {
      try { sessionStorage.setItem('cg_home_scroll', String(window.scrollY)); } catch(e){}
    }, 80);
  }, { passive: true });
}

// When user clicks a "back to the drop" style link, flag the saved scroll for restore
document.addEventListener('click', (e) => {
  const link = e.target.closest('.back-link, .about-back');
  if(!link) return;
  try {
    const savedScroll = sessionStorage.getItem('cg_home_scroll');
    if(savedScroll){
      sessionStorage.setItem('cg_home_scroll_restore', savedScroll);
    }
  } catch(err){}
  // Let the browser navigate normally — the inline restore in layout will handle the scroll
});

try {
  if(sessionStorage.getItem('cg_seen_intro') === '1'){
    primeHeroForReturn();
  } else {
    sessionStorage.setItem('cg_seen_intro', '1');
  }
} catch(e){}
window.addEventListener('pageshow', (e) => { if(e.persisted) primeHeroForReturn(); });

// ============ HERO PARALLAX ============
const heroImgs = document.querySelectorAll('.hero-image-main');
if(heroImgs.length){
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    const max = window.innerHeight;
    const yc = Math.min(y, max);
    heroImgs.forEach(el => { el.style.transform = `scale(1.02) translateY(${yc * 0.25}px)`; });
  }, { passive: true });
}

// ============ HERO SPOTLIGHT ============
const heroSpot = document.getElementById('heroSpotlight');
const heroSection = document.getElementById('home');
if(heroSpot && heroSection){
  let tx = window.innerWidth / 2, ty = window.innerHeight / 2;
  let cx = tx, cy = ty;
  document.addEventListener('mousemove', e => { tx = e.clientX; ty = e.clientY; });
  function tick(){
    cx += (tx - cx) * 0.22;
    cy += (ty - cy) * 0.22;
    const r = heroSection.getBoundingClientRect();
    heroSpot.style.setProperty('--spot-x', (cx - r.left) + 'px');
    heroSpot.style.setProperty('--spot-y', (cy - r.top) + 'px');
    requestAnimationFrame(tick);
  }
  tick();
}

})();
